<mat-expansion-panel
  [formGroup]="buttonForm()"
  [expanded]="btnIndex() === 0"
  (closed)="expansionClosed.emit()"
  (opened)="expansionOpened.emit()"
>
  <mat-expansion-panel-header>
    <mat-panel-title
      class="button-title"
      [ngClass]="{
        'button-title--success':
          buttonForm().valid && buttonData.type !== buttonTypes.None && buttonData.type !== buttonTypes.Local,
        'button-title--warning': !buttonForm().valid && !buttonForm().disabled,
      }"
    >
      {{ buttonTitle }}
    </mat-panel-title>
    <mat-panel-description class="button-title">
      {{ buttonLabel }}
    </mat-panel-description>
  </mat-expansion-panel-header>

  <app-mat-simple-select
    label="Type"
    name="buttonType"
    formControlName="type"
    [selectItems]="selectedLookUpTypes"
    [disabledItems]="nonSelectableTypes"
    [labelExplanation]="buttonTypeDescription"
    [submitted]="formSubmitted()"
    [disabled]="isDisabled"
    (valueChanged)="onButtonTypeChange($event)"
  >
  </app-mat-simple-select>

  @if (!isDisabled && isParameterVisible) {
    @if (buttonData.type === buttonTypes.Speed) {
      <app-mat-text-input
        name="dialNumber"
        appPhoneNumberSanitizer
        [formControl]="$any(buttonForm().get('parameter'))"
        [label]="parameterFieldLabel"
        [submitted]="formSubmitted()"
      ></app-mat-text-input>
    } @else {
      <app-mat-simple-select
        [label]="parameterFieldLabel"
        name="buttonParameter"
        formControlName="parameter"
        [selectItems]="parameterValues"
        [searchEnabled]="true"
        [submitted]="formSubmitted()"
        (valueChanged)="onParameterChange()"
      ></app-mat-simple-select>
    }
  }

  <app-mat-text-input
    *ngIf="buttonData.type !== buttonTypes.None && buttonData.type !== buttonTypes.Local"
    label="Label"
    name="buttonLabel"
    formControlName="label"
    explanationIcon="edit"
    [explanation]="isDisabled ? '' : 'Label can be edited'"
    [placeholder]="defaultLabel"
    [submitted]="formSubmitted()"
    [disabled]="isDisabled"
  ></app-mat-text-input>
</mat-expansion-panel>
